<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Button from "@/dsComponents/buttons/Button.vue";
import Overlay from "@/dsComponents/modals/Overlay.vue";

interface FullModalProps {
    title?: string;
    notFullWidth?: boolean;
}

const props = withDefaults(defineProps<FullModalProps>(), {
    notFullWidth: false,
});

const { t } = useI18n();
const emit = defineEmits<(event: "close") => void>();
</script>
<template>
    <Teleport to="#teleport-modal">
        <Overlay center>
            <div :class="['ds-full-modal', { 'not-full-width': props.notFullWidth }]">
                <div class="full-modal-header">
                    <span class="full-modal-title">{{ title }}</span>
                    <div class="actions">
                        <slot name="header-actions"></slot>
                        <Button
                            size="sm"
                            variant="stroke"
                            type="neutral"
                            left-icon="x"
                            @click="emit('close')"
                            :label="t('global.actions.close')"
                        ></Button>
                    </div>
                </div>
                <div class="full-modal-content">

                    <slot></slot>
                </div>
            </div>
        </Overlay>
    </Teleport>
</template>
<style lang="scss" scoped>
.ds-full-modal {
    width: 100%;
    height: 100%;
    background-color: white;
    position: fixed;
    z-index: 99999999999;
    display: flex;
    flex-direction: column;

    &.not-full-width {
        position: relative;
        max-width: 900px;
        height: 90vh;
        border-radius: 12px;
    }

    .full-modal-content {
        overflow-y: auto;
    }

    .full-modal-header {
        display: flex;
        padding: 16px 24px 16px 24px;
        justify-content: space-between;

        .actions {
            gap: 12px;
            display: flex;
        }
    }
}
</style>
